module.exports = __webpack_public_path__ + "img/home.5427e60e.svg";